import { render } from "./PendingCourseApprovalCard.vue?vue&type=template&id=f7786e06&scoped=true"
import script from "./PendingCourseApprovalCard.vue?vue&type=script&lang=js"
export * from "./PendingCourseApprovalCard.vue?vue&type=script&lang=js"

import "./PendingCourseApprovalCard.vue?vue&type=style&index=0&id=f7786e06&scoped=true&lang=css"
import "./PendingCourseApprovalCard.vue?vue&type=style&index=1&id=f7786e06&lang=css"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7786e06"],['__file',"PendingCourseApprovalCard.vue"]])

export default __exports__